import { render, staticRenderFns } from "./SettingContact.vue?vue&type=template&id=31fa0728&"
import script from "./SettingContact.vue?vue&type=script&lang=js&"
export * from "./SettingContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports